import { PostMsgParams } from '../../partners/types/partnerTypes';

export const SHOW_AXA_GOAL_DASHBOARD = 'SHOW_AXA_GOAL_DASHBOARD';

export const OPEN_DISCLAIMER = `OPEN_DISCLAIMER`;

export const CTA_BUTTON_TRIGGER = `CTA_BUTTON_TRIGGER`;

export const DOWNLOAD_DOCUMENT = 'DOWNLOAD_DOCUMENT';

export const openDisclaimer = (
  disclaimerId: string,
  params?: PostMsgParams,
  isGoBack = false,
  okActionCallBack?: () => void,
) => {
  return {
    type: OPEN_DISCLAIMER,
    payload: {
      disclaimerId: disclaimerId,
      params: params,
      isGoBack: isGoBack,
      okActionCallBack,
    },
  };
};

export const downloadDocument = (url: string) => ({
  type: DOWNLOAD_DOCUMENT,
  url,
});
